import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  OrderItemVendor,
  type OrderItemVendorConstructor,
} from './OrderItemVendor'

export const OrderItemVendorConstructorFactory =
  Factory.Sync.makeFactory<OrderItemVendorConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.company.companyName()),
    isAutoEmailPoEnabled: Factory.each(() => faker.random.boolean()),
    active: true,
  })

export const OrderItemVendorFactory = EntityFactory(
  OrderItemVendor,
  OrderItemVendorConstructorFactory
)
